export const AppEnvironments = Object.freeze({
    Production: 'prod',
    UAT: 'uat',
    Dev: 'dev',
    Local: 'local',
});

export const isProduction = () => process.env.APP_ENV === AppEnvironments.Production;
